import React, { useEffect, useRef, useState } from 'react';
import './MyAccount.css';
import {
  Avatar,
  Badge,
  Box,
  CircularProgress,
  Divider,
  FormControl,
  Menu,
  MenuItem,
  OutlinedInput,
  Select,
  Switch,
  Typography,
  Fade,
} from '@mui/material';
import Layout from '../../../components/Layout';
import TeacherNavbar from '../../../components/TeacherNavbar/TeacherNavbar';
import { useTranslation } from '../../../i18n/LanguageContext';
import ReactCountryFlag from 'react-country-flag';
import { getCodeList } from 'country-list';
import ProfileEditIcon from '../../../assets/MyAccountIcon/profile-edit-icon.svg';
import EmailNotificationIcon from '../../../assets/MyAccountIcon/email-notification-icon.svg';
import GenderPreferenceIcon from '../../../assets/MyAccountIcon/gender-preference-icon.svg';
import LanguagePreferenceIcon from '../../../assets/MyAccountIcon/language-preference-icon.svg';
import PasswordManagerIcon from '../../../assets/MyAccountIcon/password-manager-icon.svg';
import ArrowForwardIcon from '../../../assets/MyAccountIcon/arrow-forward-icon.svg';
import GenderMaleIcon from '../../../assets/MyAccountIcon/male-gender-image.png';
import GenderFemaleIcon from '../../../assets/MyAccountIcon/female-gender-image.png';
import DocumentIcon from '../../../assets/MyAccountIcon/document-icon.svg';
import SaveProfileIcon from '../../../assets/MyAccountIcon/save-profile-icon.svg';
import CloseProfileIcon from '../../../assets/MyAccountIcon/close-edit-icon.svg';
import EditAvailabilityIcon from '../../../assets/profile/book-open.svg';
// import GenderPreferenceIcon from '../../../assets/profile/people.svg';
import { MdOutlineSupportAgent } from 'react-icons/md';
import { PiBookOpenText } from 'react-icons/pi';
import { MdOutlineTimelapse } from 'react-icons/md';

import AddIcon from '@mui/icons-material/Add';
import { axiosInstance } from '../../../utils/tokenUtils';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import PasswordManagerModal from '../../../components/MyAccount/PasswordManagerModal/PasswordManagerModal';
import GenderPreferenceModal from '../../../components/MyAccount/GenderPreferenceModal/GenderPreferenceModal';
import SetInstantAvailability from '../../../components/MyAccount/SetInstantAvailability/SetInstantAvailability';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useAuth } from '../../../context/AuthContext';
import { NotificationBing } from 'iconsax-react';
import LoadingScreen from '../../../components/LoadingIcon/LoadingScreen';
import SupportHelp from '../../../components/MyAccount/Support&Help/Support&Help';
import SupportHelpModal from '../../../components/MyAccount/Support&Help/Support&Help';

// Initialize dayjs with plugins for timezone handling
dayjs.extend(utc);
dayjs.extend(timezone);

// const LevelToTeachColor = {
//   // Academic levels
//   college_level: {
//     color: '#14B334',
//     bgcolor: '#F2FFF5',
//     value: 'College Level',
//   },
//   high_school: {
//     color: '#E0AD14',
//     bgcolor: '#FFFBF0',
//     value: 'High School',
//   },
//   middle_school: {
//     color: '#6B60E7',
//     bgcolor: '#F0EFFF',
//     value: 'Middle School',
//   },
//   // Creative levels
//   beginner: {
//     color: '#1E88E5',
//     bgcolor: '#E3F2FD',
//     value: 'Beginner',
//   },
//   intermediate: {
//     color: '#FF9800',
//     bgcolor: '#FFF3E0',
//     value: 'Intermediate',
//   },
//   professional: {
//     color: '#9C27B0',
//     bgcolor: '#F3E5F5',
//     value: 'Professional',
//   },
// };

const LanguageArray = [
  { code: 'en', lang: 'English' },
  { code: 'hi', lang: 'Hindi' },
  { code: 'ar', lang: 'Arabic' },
];

const countryListObject = getCodeList();
const CountriesList = Object.entries(countryListObject).map(([code, name]) => ({
  code,
  name,
}));

// const AcademicLevelArray = [
//   { name: 'College Level', value: 'college_level' },
//   { name: 'High School', value: 'high_school' },
//   { name: 'Middle School', value: 'middle_school' },
// ];

// const CreativeLevelArray = [
//   { name: 'Beginner', value: 'beginner' },
//   { name: 'Intermediate', value: 'intermediate' },
//   { name: 'Professional', value: 'professional' },
// ];

// const LevelToTeachArray = [...AcademicLevelArray, ...CreativeLevelArray];

const HighestQualificationArray = [
  { name: 'Phd', value: 'phd' },
  { name: 'Masters', value: 'masters' },
  { name: 'Bachelors', value: 'bachelors' },
  {
    name: 'Currently pursuing Bachelors',
    value: 'currently_pursuing_bachelors',
  },
];

const ExperienceArray = [
  { value: 'All', label: 'All' },
  { value: '1-3', label: '1-3 years' },
  { value: '4-6', label: '4-6 years' },
  { value: '7-9', label: '7-9 years' },
  { value: '10+', label: '10+ years' },
];

const MyAccount = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { currentLanguage, setCurrentLanguage, translate } = useTranslation();
  const [teacherProfileDetails, setTeacherProfileDetails] = useState([]);
  const [teacherProfileDetailsInfo, setTeacherProfileDetailsInfo] = useState([]);
  const [usersDetails, setUsersDetails] = useState([]);
  const [usersDetailsInfo, setUsersDetailsInfo] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [languageList, setLanguageList] = useState([]);
  const [userLanguages, setUserLanguages] = useState([]);
  const [availableLanguages, setAvailableLanguages] = useState([]);
  const [checked, setChecked] = useState(false);
  const [emailNotificationChecked, setEmailNotificationChecked] = useState(false);
  const [pushNotificationChecked, setPushNotificationChecked] = useState(false);
  const [openPasswordManagerModal, setOpenPasswordManagerModal] = useState(false);
  const [openGenderPreferenceModal, setOpenGenderPreferenceModal] = useState(false);
  const [openInstantAvailabilityModal, setOpenInstantAvailabilityModal] = useState(false);
  const [instantAvailabilityActive, setInstantAvailabilityActive] = useState(false);
  const [availabilityDuration, setAvailabilityDuration] = useState(2);
  const [avatarImage, setAvatarImage] = useState('');
  const [openEdit, setOpenEdit] = useState(false);
  const fileInputRef = useRef(null);
  const cvFileInputRef = useRef(null);
  const navigate = useNavigate();
  const [personName, setPersonName] = useState([]);
  // const [subjectList, setSubjectList] = useState([]);
  const [timeRemaining, setTimeRemaining] = useState(0);
  const [cvFile, setCVFile] = useState(null);
  const [auth, setAuth] = useAuth();
  const [instantAvailabilityData, setInstantAvailabilityData] = useState(null);
  const [availabilityRange, setAvailabilityRange] = useState({ start: '', end: '' });
  const countdownRef = useRef(null);
  const [availabilityLoading, setAvailabilityLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [profileImageLoading, setProfileImageLoading] = useState(false);
  const [fadeIn, setFadeIn] = useState(false);
  const [openSupportHelpModal, setOpenSupportHelpModal] = useState(false);
  useEffect(() => {
    if (teacherProfileDetails?.level_of_teaching) {
      setPersonName(teacherProfileDetails?.level_of_teaching);
    }
  }, [teacherProfileDetails]);

  const handleChange = event => {
    const {
      target: { value },
    } = event;
    setPersonName(typeof value === 'string' ? value.split(',') : value);

    setTeacherProfileDetailsInfo(prev => ({
      ...prev,
      level_of_teaching: typeof value === 'string' ? value.split(',') : value,
    }));
  };

  useEffect(() => {
    // if (teacherProfileDetails?.subjects && Array.isArray(teacherProfileDetails.subjects)) {
    //   const subjectValues = teacherProfileDetails.subjects
    //     .filter(name => name && typeof name === 'string')
    //     .map(name => getSubjectValue(name))
    //     .filter(value => value);
    //   setSubjectList(subjectValues);
    // }
  }, [teacherProfileDetails]);

  // const handleSubjectChange = (event) => {
  //   const {
  //     target: { value },
  //   } = event;
  //   setSubjectList(typeof value === "string" ? value.split(",") : value);

  //   setTeacherProfileDetailsInfo((prev) => ({
  //     ...prev,
  //     subject: typeof value === "string" ? value.split(",") : value,
  //   }));
  // };

  useEffect(() => {
    if (teacherProfileDetails?.teaching_lang) {
      setLanguageList(teacherProfileDetails?.teaching_lang);
    }
  }, [teacherProfileDetails]);

  const handleLanguageChange = event => {
    const {
      target: { value },
    } = event;
    setLanguageList(typeof value === 'string' ? value.split(',') : value);

    setTeacherProfileDetailsInfo(prev => ({
      ...prev,
      teaching_lang: typeof value === 'string' ? value.split(',') : value,
    }));
  };

  const getTeacherProfileDetails = async () => {
    try {
      setLoading(true);
      setFadeIn(false);
      const { data } = await axiosInstance.get('/teachers');
      setTeacherProfileDetails(data);
      setEmailNotificationChecked(data.allow_email_notifications || false);
      setPushNotificationChecked(data.allow_push_notifications || false);
      setLoading(false);

      // Delay setting fadeIn to true to allow time for loading screen to exit
      setTimeout(() => {
        setFadeIn(true);
      }, 100);
    } catch (error) {
      console.log(error);
      setLoading(false);
      setFadeIn(true);
    }
  };

  const getUsersDetails = async () => {
    try {
      setLoading(true);
      const { data } = await axiosInstance.get('/auth/users/me');
      setUsersDetails(data);
      setAvatarImage(data?.profile_image);

      // Set user languages from the response
      if (data?.languages && Array.isArray(data.languages)) {
        setUserLanguages(data.languages);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  // Get available languages from the API
  const getLanguagesList = async () => {
    try {
      const { data } = await axiosInstance.get('/auth/languages');
      setAvailableLanguages(data);
    } catch (error) {
      console.log('Error fetching languages list:', error);
    }
  };

  // Quietly refresh teacher profile data without triggering global loader
  const refreshTeacherProfileQuietly = async () => {
    try {
      const { data } = await axiosInstance.get('/teachers');
      setTeacherProfileDetails(data);
    } catch (error) {
      console.log(error);
    }
  };

  // Get cities based on selected country
  const getCitiesList = async countryId => {
    if (!countryId) return;
    try {
      const { data } = await axiosInstance.get(`/auth/countries/${countryId}/cities`);
      setCityList(data);
    } catch (error) {
      console.log('Error fetching cities list:', error);
    }
  };

  useEffect(() => {
    getTeacherProfileDetails();
    getUsersDetails();
    getCountriesList();
    getLanguagesList();
  }, [avatarImage, openEdit]);

  // Fetch cities when country changes
  useEffect(() => {
    if (usersDetailsInfo?.country?.id) {
      getCitiesList(usersDetailsInfo.country.id);
    }
  }, [usersDetailsInfo?.country?.id]);

  useEffect(() => {
    if (teacherProfileDetails) {
      setTeacherProfileDetailsInfo({
        id: teacherProfileDetails?.id,
        highest_qualification: teacherProfileDetails?.highest_qualification,
        degree_name: teacherProfileDetails?.degree_name,
        institute: teacherProfileDetails?.institute,
        level_of_teaching: teacherProfileDetails?.level_of_teaching,
        teaching_lang: teacherProfileDetails?.teaching_lang,
        years_of_experience: teacherProfileDetails?.years_of_experience,
        descriptions: teacherProfileDetails?.descriptions,
        teacher_type: teacherProfileDetails?.teacher_type,
      });
    }
    if (usersDetails) {
      setUsersDetailsInfo({
        id: usersDetails?.id,
        first_name: usersDetails?.first_name,
        last_name: usersDetails?.last_name,
        phone_no: usersDetails?.phone_no,
        country: usersDetails?.country,
        city: usersDetails?.city,
        languages: usersDetails?.languages || [],
        gender: usersDetails?.gender,
      });
    }
  }, [teacherProfileDetails, usersDetails]);

  const convertUtcToLocalTime = (timeStr, validUntil) => {
    if (!timeStr || !validUntil) return '';
    const datePart = dayjs.utc(validUntil).format('YYYY-MM-DD');
    const utcTimestamp = `${datePart}T${timeStr}:00Z`;
    return dayjs.utc(utcTimestamp).local().format('HH:mm');
  };

  const formatDuration = seconds => {
    if (!seconds || seconds <= 0) return '00:00:00';
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };

  const checkInstantAvailability = async () => {
    try {
      setAvailabilityLoading(true);
      const { data } = await axiosInstance.get('/teachers/instant-availability');

      // Store the full response data
      setInstantAvailabilityData(data);

      // Check if we have a valid instant availability response
      if (data && data.start_time && data.end_time) {
        // Parse times as UTC (add Z suffix if not present)
        let startTimeUtc = dayjs.utc(data.start_time + (data.start_time.endsWith('Z') ? '' : 'Z'));
        let endTimeUtc = dayjs.utc(data.end_time + (data.end_time.endsWith('Z') ? '' : 'Z'));

        // Handle case where end time is before start time on same date (crosses midnight)
        if (endTimeUtc.isBefore(startTimeUtc) || endTimeUtc.isSame(startTimeUtc)) {
          // Add 1 day to end time
          endTimeUtc = endTimeUtc.add(1, 'day');
        }

        // Convert to local timezone
        const startTimeLocal = startTimeUtc.local();
        const endTimeLocal = endTimeUtc.local();
        const nowLocal = dayjs();

        // Calculate seconds remaining until end time (in local timezone)
        const secondsRemaining = endTimeLocal.diff(nowLocal, 'second');

        if (secondsRemaining > 0) {
          // Availability is active
          setInstantAvailabilityActive(true);
          setChecked(true);

          // Calculate duration in hours from start to end time
          const durationMinutes = endTimeLocal.diff(startTimeLocal, 'minute');
          setAvailabilityDuration(Math.ceil(durationMinutes / 60));

          // Set the exact remaining time for the countdown
          setTimeRemaining(secondsRemaining);

          // Format start and end times for display
          const startLocal = startTimeLocal.format('HH:mm');
          const endLocal = endTimeLocal.format('HH:mm');
          setAvailabilityRange({ start: startLocal, end: endLocal });
        } else {
          // Availability has expired
          setInstantAvailabilityActive(false);
          setChecked(false);
          setTimeRemaining(0);
        }
      } else {
        // No valid availability data
        setInstantAvailabilityActive(false);
        setChecked(false);
        setTimeRemaining(0);
      }
      setAvailabilityLoading(false);
    } catch (error) {
      // If error status is 404, that means no active availability
      if (error.response && error.response.status === 404) {
        setInstantAvailabilityActive(false);
        setChecked(false);
        setTimeRemaining(0);
      } else {
        console.error('Error checking instant availability:', error);
      }
      setAvailabilityLoading(false);
    }
  };

  useEffect(() => {
    checkInstantAvailability();
  }, []);

  useEffect(() => {
    if (!instantAvailabilityActive) return;
    const intervalId = setInterval(() => {
      checkInstantAvailability();
    }, 60000);
    return () => clearInterval(intervalId);
  }, [instantAvailabilityActive]);

  useEffect(() => {
    if (instantAvailabilityActive) {
      clearInterval(countdownRef.current);
      countdownRef.current = setInterval(() => {
        setTimeRemaining(prev => {
          if (prev <= 1) {
            clearInterval(countdownRef.current);
            countdownRef.current = null;
            setInstantAvailabilityActive(false);
            setChecked(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } else {
      clearInterval(countdownRef.current);
      countdownRef.current = null;
      setTimeRemaining(0);
    }
    return () => clearInterval(countdownRef.current);
  }, [instantAvailabilityActive]);

  const handleCheckedChange = event => {
    const newValue = event.target.checked;
    setChecked(newValue);

    if (newValue) {
      setOpenInstantAvailabilityModal(true);
    } else {
      setInstantAvailabilityActive(false);
      clearInterval(countdownRef.current);
      countdownRef.current = null;
      setTimeRemaining(0);
      setAvailabilityRange({ start: '', end: '' });
      disableInstantAvailability();
    }
  };

  const handleCloseInstantAvailabilityModal = () => {
    setOpenInstantAvailabilityModal(false);
    if (!instantAvailabilityActive) {
      setChecked(false);
    }
  };

  const handleConfirmAvailability = async hours => {
    setOpenInstantAvailabilityModal(false);
    setInstantAvailabilityActive(true);
    setChecked(true);
    setAvailabilityDuration(hours);
    try {
      const response = await axiosInstance.post('/teachers/instant-availability', {
        duration_hours: hours,
      });
      if (response.status === 200 || response.status === 201) {
        await checkInstantAvailability();
        toast.success(`You are now available for ${hours} hours`);
      } else {
        setInstantAvailabilityActive(false);
        setChecked(false);
        toast.error('Failed to set availability');
      }
    } catch (error) {
      console.error('Error setting availability:', error);
      setInstantAvailabilityActive(false);
      setChecked(false);
      setTimeRemaining(0);
      toast.error(error.response?.data?.detail || 'Failed to set availability');
    }
  };

  const disableInstantAvailability = async () => {
    try {
      const response = await axiosInstance.delete('/teachers/instant-availability');

      if (response.status === 200 || response.status === 204) {
        setInstantAvailabilityActive(false);
        setChecked(false);
        setTimeRemaining(0);
        setInstantAvailabilityData(null);
        toast.success('Instant availability disabled');
      } else {
        setChecked(true);
        toast.error(response.data?.detail || 'Failed to disable availability');
      }
    } catch (error) {
      console.error('Error disabling availability:', error);
      setChecked(true);
      toast.error(error.response?.data?.detail || 'Failed to disable availability');
    }
  };

  const updateNotificationSettings = async (type, value) => {
    try {
      const updateData = {
        [type]: value,
      };

      await axiosInstance.patch('/teachers', updateData);
      if (type === 'allow_email_notifications') {
        setEmailNotificationChecked(value);
      } else if (type === 'allow_push_notifications') {
        setPushNotificationChecked(value);
      }
      return true;
    } catch (error) {
      console.log(error);
      if (type === 'allow_email_notifications') {
        setEmailNotificationChecked(!value);
      } else if (type === 'allow_push_notifications') {
        setPushNotificationChecked(!value);
      }
      return false;
    }
  };

  const handleEmailNotificationChange = async event => {
    const newValue = event.target.checked;
    setEmailNotificationChecked(newValue);
    const success = await updateNotificationSettings('allow_email_notifications', newValue);
    if (success) {
      toast.success(
        newValue
          ? 'Email notifications enabled successfully'
          : 'Email notifications disabled successfully'
      );
    } else {
      toast.error('Failed to update email notification settings');
    }
  };
  const handlePushNotificationChange = async event => {
    const newValue = event.target.checked;
    setPushNotificationChecked(newValue);
    const success = await updateNotificationSettings('allow_push_notifications', newValue);
    if (success) {
      toast.success(
        newValue
          ? 'Push notifications enabled successfully'
          : 'Push notifications disabled successfully'
      );
    } else {
      toast.error('Failed to update push notification settings');
    }
  };

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleImageChange = async event => {
    try {
      const file = event.target.files[0];
      if (!file) return;

      setProfileImageLoading(true);
      const formData = new FormData();
      formData.append('file', file);
      const localImageUrl = URL.createObjectURL(file);
      setAvatarImage(localImageUrl);

      const res = await axiosInstance.post('/auth/users/profile_upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (res?.status === 200) {
        setAvatarImage(res.data.profile_image);
        // Update auth context with new profile image from API response
        setAuth(prev => ({
          ...prev,
          profile_image: res.data.profile_image,
        }));
        toast.success(`${translate('myAccount', 'profileImageSuccessMessageText')}`);
      } else {
        setAvatarImage(usersDetails?.profile_image || '');
      }
      setProfileImageLoading(false);
    } catch (error) {
      console.error('Error uploading image:', error);
      setAvatarImage(usersDetails?.profile_image || '');
      toast.error(`${translate('myAccount', 'profileImageFailedMessageText')}`);
      setProfileImageLoading(false);
    }
  };

  const handleEditSpecialisationClick = () => {
    navigate('/instructor/account/edit-specialisation');
  };

  const handleRescheduledRequestClick = () => {
    navigate('/instructor/account/reschedule-request');
  };

  const handleGenderPreferenceClick = () => {
    setOpenGenderPreferenceModal(true);
  };
  const handlePasswordManagerClick = () => {
    setOpenPasswordManagerModal(true);
  };
  const handleSupportHelpClick = () => {
    setOpenSupportHelpModal(true);
  };
  const handleLanguagePreferenceClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageSelection = languageId => {
    // Find if the language is already selected
    const isSelected = usersDetailsInfo.languages.some(lang => lang.id === languageId);
    let updatedLanguages;

    if (isSelected) {
      // Remove language if already selected
      updatedLanguages = usersDetailsInfo.languages.filter(lang => lang.id !== languageId);
    } else {
      // Add language if not selected
      const languageToAdd = availableLanguages.find(lang => lang.id === languageId);
      if (languageToAdd) {
        updatedLanguages = [...usersDetailsInfo.languages, languageToAdd];
      } else {
        updatedLanguages = [...usersDetailsInfo.languages];
      }
    }

    // Update state
    setUsersDetailsInfo(prev => ({
      ...prev,
      languages: updatedLanguages,
    }));

    // If in edit mode, this will be submitted when saving the form
    // If not in edit mode, we should update it immediately
    if (!openEdit) {
      updateUserLanguages(updatedLanguages.map(lang => lang.id));
    }
  };

  const updateUserLanguages = async languageIds => {
    try {
      const response = await axiosInstance.patch('/auth/users/me', {
        language_ids: languageIds,
      });

      if (response.status === 200 || response.status === 204) {
        getUsersDetails(); // Refresh user details
        toast.success('Languages updated successfully');
      }
    } catch (error) {
      console.error('Error updating languages:', error);
      toast.error('Failed to update languages');
    }
  };

  function formatText(input) {
    return input.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
  }

  const handleEdit = () => {
    setOpenEdit(true);
  };
  const handleCancel = () => {
    setOpenEdit(false);
  };
  const handleSave = async () => {
    try {
      setLoading(true);
      // Prepare teacher profile data as a regular JSON object
      const teacherData = {
        highest_qualification: teacherProfileDetailsInfo?.highest_qualification || '',
        degree_name: teacherProfileDetailsInfo?.degree_name || '',
        institute: teacherProfileDetailsInfo?.institute || '',
        level_of_teaching: teacherProfileDetailsInfo?.level_of_teaching || [],
        teaching_lang: teacherProfileDetailsInfo?.teaching_lang || [],
        years_of_experience: teacherProfileDetailsInfo?.years_of_experience || '',
        descriptions: teacherProfileDetailsInfo?.descriptions || null,
        cv: teacherProfileDetailsInfo?.cv || null, // Include the CV URL in the update
      };

      // User data for the separate endpoint - include country_id and city_id
      const usersData = {
        phone_no: usersDetailsInfo?.phone_no,
        country_id: usersDetailsInfo?.country?.id,
        city_id: usersDetailsInfo?.city?.id,
        language_ids: usersDetailsInfo?.languages?.map(lang => lang.id) || [],
      };

      // Update teacher profile with JSON data
      const res = await axiosInstance.patch('/teachers', teacherData);

      // Update user data
      const response = await axiosInstance.patch('/auth/users/me', usersData);

      if (
        (res?.status === 200 || res?.status === 204) &&
        (response?.status === 200 || response?.status === 204)
      ) {
        // Update auth context with new user details and country
        setAuth(prev => ({
          ...prev,
          country: usersDetailsInfo?.country,
          city: usersDetailsInfo?.city,
        }));

        setOpenEdit(false);
        setCVFile(null);
        // Refresh profile data after saving
        getTeacherProfileDetails();
        getUsersDetails();
        toast.success(`${translate('myAccount', 'profileUpdateSuccessMessageText')}`);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error saving profile:', error);
      toast.error(`${translate('myAccount', 'profileUpdateFailedMessageText')}`);
      setLoading(false);
    }
  };

  const getHighestQualification = value => {
    const qualification = HighestQualificationArray.find(qual => qual.value === value);
    return qualification ? qualification?.name : '---';
  };

  const handleCVFileChange = async event => {
    try {
      const file = event.target.files[0];
      if (!file) return;

      // Create FormData for file upload
      const formData = new FormData();
      formData.append('file', file);

      // First upload the CV document
      const uploadResponse = await axiosInstance.post('/teachers/documents/cv', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (uploadResponse?.status === 200 || uploadResponse?.status === 201) {
        // Store the file URL returned from the upload
        const cvUrl = uploadResponse.data;

        setCVFile(file);
        setTeacherProfileDetailsInfo(prev => ({
          ...prev,
          cv: cvUrl, // Store the URL instead of just the filename
        }));

        toast.success(`${translate('myAccount', 'cvSelectedMessageText')}`);
      } else {
        throw new Error('Failed to upload CV');
      }
    } catch (error) {
      console.error('Error uploading CV:', error);
      toast.error(`${translate('myAccount', 'cvSelectionFailedMessageText')}`);
    }
  };

  // const getSubjectValue = (name) => {
  //   if (!name || typeof name !== 'string') {
  //     return '';
  //   }

  //   const subject = Object.entries(subjectToValue).find(([key, val]) =>
  //     val.value.toLowerCase() === name.toLowerCase()
  //   );
  //   return subject ? subject[0] : name.toLowerCase().replace(' ', '_');
  // };

  const handleTeacherTypeChange = event => {
    const newTeacherType = event.target.value;

    setTeacherProfileDetailsInfo(prev => ({
      ...prev,
      teacher_type: newTeacherType,
      level_of_teaching: [],
    }));

    setPersonName([]);
  };

  // Add function to fetch countries list
  const getCountriesList = async () => {
    try {
      const { data } = await axiosInstance.get('/auth/countries');
      setCountryList(data);
    } catch (error) {
      console.log('Error fetching countries list:', error);
    }
  };

  if (loading) {
    return (
      <Layout title="Klass Online | My Account">
        <Box className="relative h-screen w-full overflow-hidden">
          <Box className="sticky top-0 left-0 right-0 z-[1000] bg-white pr-[10px]">
            <TeacherNavbar />
            <Box className="h-[calc(100vh-64px)] overflow-auto relative bg-[#F9F9F9] rounded-lg mr-[10px] flex justify-center items-center">
              <LoadingScreen />
            </Box>
          </Box>
        </Box>
      </Layout>
    );
  }

  return (
    <Layout title="Klass Online | My Account">
      <Box className="relative h-screen w-full overflow-hidden">
        <Box className="sticky top-0 left-0 right-0 z-[1000] bg-white pr-[10px]">
          <TeacherNavbar />
          <Box className="h-[calc(100vh-64px)] overflow-auto relative bg-[#F9F9F9] rounded-lg mr-[10px]">
            <Fade in={fadeIn} timeout={800}>
              <Box className="flex flex-col p-[1rem] gap-3">
                <Typography className="account-title">
                  {translate('myAccount', 'myAccountText')}
                </Typography>
                <Box className="flex items-center gap-4">
                  <input
                    type="file"
                    ref={fileInputRef}
                    accept="image/*"
                    style={{ display: 'none' }}
                    onChange={handleImageChange}
                  />
                  <Badge
                    overlap="circular"
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    badgeContent={
                      profileImageLoading ? (
                        <CircularProgress size={22} thickness={4} />
                      ) : (
                        <AddIcon
                          onClick={handleImageClick}
                          sx={{
                            width: '22px',
                            height: '22px',
                            background: '#0A5EF3',
                            borderRadius: '50%',
                            color: '#FFF',
                            cursor: 'pointer',
                          }}
                        />
                      )
                    }
                  >
                    <Avatar src={avatarImage} sx={{ width: '110px', height: '110px' }} />
                  </Badge>
                  <Box className="flex flex-col gap-2">
                    <Box className="flex items-center gap-4">
                      <div className="teacher-profile-name">
                        {usersDetails?.first_name} {usersDetails?.last_name}
                      </div>
                      <Divider
                        orientation="vertical"
                        flexItem
                        sx={{
                          height: '20px',
                          borderColor: '#D5DEE3',
                        }}
                      />
                      {usersDetails?.country?.name
                        ? (() => {
                            const countryMatch = CountriesList.find(
                              country => country.name.toLowerCase() === usersDetails?.country?.name
                            );
                            return (
                              countryMatch && (
                                <Box className="flex items-center gap-4">
                                  <ReactCountryFlag countryCode={countryMatch.code} svg />
                                </Box>
                              )
                            );
                          })()
                        : '---'}
                    </Box>
                    <div className="teacher-profile-email">{usersDetails?.email}</div>
                    <Box className="flex flex-col gap-1">
                      {checked && availabilityRange.start && (
                        <div className="availability-timer-container">
                          {availabilityLoading ? (
                            <CircularProgress size={20} thickness={4} />
                          ) : (
                            <Typography
                              className="account-availability-timer"
                              style={{ fontWeight: 'bold' }}
                            >
                              {formatDuration(timeRemaining)}
                            </Typography>
                          )}
                        </div>
                      )}
                      <Box className="flex items-center gap-2">
                        <div className="teacher-set-availability-text">
                          {translate('myAccount', 'setAvailabilityText')}
                        </div>
                        <Switch
                          checked={checked}
                          onChange={handleCheckedChange}
                          inputProps={{ 'aria-label': 'controlled' }}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Box>
                <Box className="flex justify-end gap-3">
                  {openEdit ? (
                    <Box className="flex items-center gap-3">
                      <Box className="flex items-center gap-1 cursor-pointer" onClick={handleSave}>
                        {loading ? (
                          <CircularProgress size={20} thickness={4} />
                        ) : (
                          <>
                            <img src={SaveProfileIcon} alt="save" />
                            <div className="edit-information-text">
                              {translate('myAccount', 'saveText')}
                            </div>
                          </>
                        )}
                      </Box>
                      <Box
                        className="flex items-center gap-1 cursor-pointer"
                        onClick={handleCancel}
                      >
                        <img src={CloseProfileIcon} alt="save" />
                        <div className="cancel-information-text">
                          {translate('myAccount', 'cancelText')}
                        </div>
                      </Box>
                    </Box>
                  ) : (
                    <Box className="flex items-center gap-1 cursor-pointer" onClick={handleEdit}>
                      <img src={ProfileEditIcon} alt="edit" />
                      <div className="edit-information-text">
                        {translate('myAccount', 'editInformationText')}
                      </div>
                    </Box>
                  )}
                </Box>

                <Box className="flex flex-wrap items-center content-center gap-4 self-stretch p-3 rounded-md bg-[#FFF] w-[100%]">
                  <Typography className="account-section-heading">
                    {translate('myAccount', 'descriptionText') || 'Description'}
                  </Typography>
                  <Box className="flex flex-wrap items-center content-center gap-4 self-stretch p-3 rounded-md bg-[#FAFAFA] w-[100%]">
                    {openEdit ? (
                      <textarea
                        placeholder={
                          translate('myAccount', 'addDescriptionPlaceholderText') ||
                          'Add a description about yourself, your teaching approach, and your expertise...'
                        }
                        value={teacherProfileDetailsInfo?.descriptions || ''}
                        onChange={e =>
                          setTeacherProfileDetailsInfo(prev => ({
                            ...prev,
                            descriptions: e.target.value,
                          }))
                        }
                        className="description-text-area"
                      />
                    ) : (
                      <div className="w-full">
                        {teacherProfileDetails?.descriptions ? (
                          <Typography className="description-content">
                            {teacherProfileDetails.descriptions}
                          </Typography>
                        ) : (
                          <Box className="add-description-placeholder">
                            <Typography>
                              {translate('myAccount', 'addDescriptionText') ||
                                'Add a description about yourself to help students know more about you.'}
                            </Typography>
                          </Box>
                        )}
                      </div>
                    )}
                  </Box>
                </Box>

                <Box className="flex flex-wrap items-center content-center gap-4 self-stretch p-3 rounded-md bg-[#FFF] w-[100%]">
                  <Typography className="account-section-heading">
                    {translate('myAccount', 'personalInformationText')}
                  </Typography>
                  <Box className="flex flex-wrap items-center content-center gap-4 self-stretch p-3 rounded-md bg-[#FAFAFA] w-[100%]">
                    <Box className="account-field-container w-[32%]">
                      <Typography className="account-field-label">
                        {translate('myAccount', 'firstNameText')}
                      </Typography>
                      <Typography className="account-field-value">
                        {usersDetails?.first_name || '---'}
                      </Typography>
                    </Box>
                    <Box className="account-field-container w-[32%]">
                      <Typography className="account-field-label">
                        {translate('myAccount', 'lastNameText')}
                      </Typography>
                      <Typography className="account-field-value">
                        {usersDetails?.last_name || '---'}
                      </Typography>
                    </Box>
                    <Box className="account-field-container w-[32%]">
                      <Typography className="account-field-label">
                        {translate('myAccount', 'genderText')}
                      </Typography>
                      <Box className="account-field-value">
                        <Box className="flex items-center gap-2">
                          <img
                            src={
                              usersDetails?.gender === 'male' ? GenderMaleIcon : GenderFemaleIcon
                            }
                            alt="Male"
                          />
                          <Typography>{formatText(usersDetails?.gender || '---')}</Typography>
                        </Box>
                      </Box>
                    </Box>
                    <Box className="account-field-container w-[32%]">
                      <Typography className="account-field-label">
                        {translate('myAccount', 'teacherTypeText') || 'Teacher Type'}
                      </Typography>
                      <Typography className="account-field-value capitalize">
                        {teacherProfileDetails?.teacher_type
                          ? formatText(teacherProfileDetails.teacher_type)
                          : '---'}
                      </Typography>
                    </Box>
                    <Box className="account-field-container w-[32%]">
                      <Typography className="account-field-label">Country</Typography>
                      {openEdit ? (
                        <>
                          <FormControl
                            sx={{
                              display: 'flex',
                              justifyContent: 'flex-end',
                              width: '100%',
                            }}
                          >
                            <Select
                              displayEmpty
                              value={usersDetailsInfo?.country?.id || ''}
                              onChange={e => {
                                const selectedCountry = countryList.find(
                                  country => country.id === e.target.value
                                );
                                setUsersDetailsInfo(prev => ({
                                  ...prev,
                                  country: selectedCountry,
                                  city: null, // Reset city when country changes
                                }));
                                getCitiesList(e.target.value);
                              }}
                              input={
                                <OutlinedInput
                                  sx={{
                                    height: '40px',
                                    fontSize: '14px',
                                    padding: '8px 2px',
                                    borderRadius: '8px',
                                    border: '1px solid rgba(0, 0, 0, 0.10)',
                                    background: '#FFF',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                  }}
                                />
                              }
                              renderValue={selected => {
                                const country = countryList.find(c => c.id === selected);
                                if (!country) return 'Select Country';
                                return (
                                  <Box className="flex items-center gap-2">
                                    <ReactCountryFlag countryCode={country.code} svg />
                                    <span>{country.name}</span>
                                  </Box>
                                );
                              }}
                            >
                              {countryList.map(country => (
                                <MenuItem key={country.id} value={country.id}>
                                  <Box className="flex items-center gap-2">
                                    <ReactCountryFlag countryCode={country.code} svg />
                                    <span>{country.name}</span>
                                  </Box>
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </>
                      ) : (
                        <Box className="flex items-center gap-2 account-field-value">
                          {usersDetails?.country?.code && (
                            <ReactCountryFlag countryCode={usersDetails.country.code} svg />
                          )}
                          <span>{usersDetails?.country?.name || '---'}</span>
                        </Box>
                      )}
                    </Box>
                    <Box className="account-field-container w-[32%]">
                      <Typography className="account-field-label">
                        {translate('myAccount', 'cityText') || 'City'}
                      </Typography>
                      {openEdit ? (
                        <>
                          <FormControl
                            sx={{
                              display: 'flex',
                              justifyContent: 'flex-end',
                              width: '100%',
                            }}
                          >
                            <Select
                              displayEmpty
                              value={usersDetailsInfo?.city?.id || ''}
                              onChange={e => {
                                const selectedCity = cityList.find(
                                  city => city.id === e.target.value
                                );
                                setUsersDetailsInfo(prev => ({
                                  ...prev,
                                  city: selectedCity,
                                }));
                              }}
                              input={
                                <OutlinedInput
                                  sx={{
                                    height: '40px',
                                    fontSize: '14px',
                                    padding: '8px 2px',
                                    borderRadius: '8px',
                                    border: '1px solid rgba(0, 0, 0, 0.10)',
                                    background: '#FFF',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                  }}
                                />
                              }
                              renderValue={selected => {
                                const city = cityList.find(c => c.id === selected);
                                return city ? city.name : 'Select City';
                              }}
                              disabled={!usersDetailsInfo?.country?.id}
                            >
                              {cityList.map(city => (
                                <MenuItem key={city.id} value={city.id}>
                                  {city.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </>
                      ) : (
                        <Typography className="account-field-value">
                          {usersDetails?.city?.name || '---'}
                        </Typography>
                      )}
                    </Box>
                    <Box className="account-field-container w-[32%]">
                      <Typography className="account-field-label">
                        {translate('myAccount', 'phoneNumberText')}
                      </Typography>
                      {openEdit ? (
                        <input
                          type="text"
                          placeholder={translate('myAccount', 'editInputPlaceholderText')}
                          value={usersDetailsInfo?.phone_no || ''}
                          onChange={e =>
                            setUsersDetailsInfo(prev => ({
                              ...prev,
                              phone_no: e.target.value,
                            }))
                          }
                          className="edit-task-modal-form-input"
                        />
                      ) : (
                        <Typography className="account-field-value">
                          {usersDetails?.phone_no || '---'}
                        </Typography>
                      )}
                    </Box>
                    <Box className="account-field-container w-[32%]">
                      <Typography className="account-field-label">
                        {translate('myAccount', 'documentText')}
                      </Typography>
                      <Box className="account-field-value">
                        <Box className="flex items-center gap-2">
                          <img src={DocumentIcon} alt="Male" />
                          <Typography className="account-document-name">Document.pdf</Typography>

                          <a
                            href={`https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(
                              teacherProfileDetails.document
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="view-button"
                          >
                            View
                          </a>
                        </Box>
                      </Box>
                    </Box>
                    <Box className="account-field-container w-[32%]">
                      <Typography className="account-field-label">
                        {translate('myAccount', 'dobText')}
                      </Typography>
                      <Typography className="account-field-value">
                        {usersDetails?.dob ? dayjs(usersDetails?.dob).format('DD-MM-YYYY') : '---'}
                      </Typography>
                    </Box>
                    <Box className="account-field-container w-[32%]">
                      <Typography className="account-field-label">
                        {translate('myAccount', 'registrationOnText')}
                      </Typography>
                      <Typography className="account-field-value">
                        {teacherProfileDetails?.created_at
                          ? dayjs(teacherProfileDetails.created_at).format('DD-MM-YYYY')
                          : '---'}
                      </Typography>
                    </Box>
                    {/* <Box className="flex flex-col gap-2 w-[32%]">
                      <Typography className="prime-session-details-key-text">
                        {translate('myAccount', 'languagesText') || 'Preferred Languages'}
                      </Typography>
                      <Box className="flex flex-wrap gap-1">
                        {usersDetails?.languages && usersDetails.languages.length > 0 ? (
                          usersDetails.languages.map(language => (
                            <Box
                              key={language.id}
                              sx={{
                                backgroundColor: '#E3F2FD',
                                color: '#1E88E5',
                                borderRadius: '4px',
                                padding: '2px 8px',
                                fontSize: '12px',
                                display: 'inline-flex',
                                alignItems: 'center',
                                marginBottom: '4px',
                              }}
                            >
                              {language.name}
                            </Box>
                          ))
                        ) : (
                          <Typography className="prime-session-details-value-text">---</Typography>
                        )}
                      </Box>
                    </Box> */}
                  </Box>
                </Box>
                <Box className="flex flex-wrap items-center content-center gap-4 self-stretch p-3 rounded-md bg-[#FFF] w-[100%]">
                  <Typography className="account-section-heading">
                    {translate('myAccount', 'educationBackgroundText')}
                  </Typography>
                  <Box className="flex flex-wrap items-center content-center gap-4 self-stretch p-3 rounded-md bg-[#FAFAFA] w-[100%]">
                    <Box className="account-field-container w-[32%]">
                      <Typography className="account-field-label">
                        {translate('myAccount', 'highestQualificationText')}
                      </Typography>
                      {openEdit ? (
                        <>
                          <FormControl
                            sx={{
                              display: 'flex',
                              justifyContent: 'flex-end',
                              width: '100%',
                            }}
                          >
                            <Select
                              displayEmpty
                              value={teacherProfileDetailsInfo?.highest_qualification || ''}
                              onChange={e =>
                                setTeacherProfileDetailsInfo(prev => ({
                                  ...prev,
                                  highest_qualification: e.target.value,
                                }))
                              }
                              input={
                                <OutlinedInput
                                  sx={{
                                    height: '40px',
                                    fontSize: '14px',
                                    padding: '8px 2px',
                                    borderRadius: '8px',
                                    border: '1px solid rgba(0, 0, 0, 0.10)',
                                    background: '#FFF',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                  }}
                                />
                              }
                              renderValue={selected => {
                                return getHighestQualification(selected);
                              }}
                            >
                              {HighestQualificationArray.map(qual => (
                                <MenuItem key={qual?.value} value={qual?.value}>
                                  {qual?.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </>
                      ) : (
                        <Typography className="account-field-value">
                          {formatText(teacherProfileDetails?.highest_qualification || '---')}
                        </Typography>
                      )}
                    </Box>
                    <Box className="account-field-container w-[32%]">
                      <Typography className="account-field-label">
                        {translate('myAccount', 'acadminTranscriptText')}
                      </Typography>
                      <Box className="account-field-value">
                        <Box className="flex items-center gap-2">
                          <img src={DocumentIcon} alt="Male" />

                          <Typography className="account-document-name">
                            Academic Transcript.pdf
                          </Typography>

                          <a
                            href={`https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(
                              teacherProfileDetails.academic_transcript
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="view-button"
                          >
                            View
                          </a>
                        </Box>
                      </Box>
                    </Box>
                    <Box className="account-field-container w-[32%]">
                      <Typography className="account-field-label">
                        {translate('myAccount', 'degreeNameText')}
                      </Typography>
                      {openEdit ? (
                        <input
                          type="text"
                          placeholder={translate('myAccount', 'editInputPlaceholderText')}
                          value={teacherProfileDetailsInfo?.degree_name || ''}
                          onChange={e =>
                            setTeacherProfileDetailsInfo(prev => ({
                              ...prev,
                              degree_name: e.target.value,
                            }))
                          }
                          className="edit-task-modal-form-input"
                        />
                      ) : (
                        <Typography className="account-field-value">
                          {teacherProfileDetails?.degree_name}
                        </Typography>
                      )}
                    </Box>
                    <Box className="account-field-container w-[32%]">
                      <Typography className="account-field-label">
                        {translate('myAccount', 'instituteText')}
                      </Typography>
                      {openEdit ? (
                        <input
                          type="text"
                          placeholder={translate('myAccount', 'editInputPlaceholderText')}
                          value={teacherProfileDetailsInfo?.institute || ''}
                          onChange={e =>
                            setTeacherProfileDetailsInfo(prev => ({
                              ...prev,
                              institute: e.target.value,
                            }))
                          }
                          className="edit-task-modal-form-input"
                        />
                      ) : (
                        <Typography className="account-field-value">
                          {teacherProfileDetails?.institute}
                        </Typography>
                      )}
                    </Box>
                    <Box className="account-field-container w-[32%]">
                      <Typography className="account-field-label">
                        {translate('myAccount', 'yearsText')}
                      </Typography>
                      <Typography className="account-field-value">2021-2025</Typography>
                    </Box>
                    <Box className="account-field-container w-[32%]">
                      <Typography className="account-field-label">
                        {translate('myAccount', 'cvText')}
                      </Typography>
                      <Box className="account-field-value">
                        {openEdit ? (
                          <Box
                            className="cv-upload-container"
                            onClick={() => cvFileInputRef.current.click()}
                          >
                            <input
                              type="file"
                              ref={cvFileInputRef}
                              accept=".pdf,.doc,.docx"
                              style={{ display: 'none' }}
                              onChange={handleCVFileChange}
                            />
                            <div className="cv-upload-icon">
                              <img src={DocumentIcon} alt="Document" />
                            </div>
                            <div className="cv-upload-text">
                              {cvFile ? cvFile.name : translate('myAccount', 'attachFilesText')}
                            </div>
                            <div className="cv-upload-arrow">
                              <img src={ArrowForwardIcon} alt="arrow" />
                            </div>
                          </Box>
                        ) : (
                          <Box className="flex items-center gap-2">
                            <img src={DocumentIcon} alt="Document" />
                            <Typography className="account-document-name">CV.pdf</Typography>
                            {teacherProfileDetails?.cv && (
                              <a
                                href={`https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(
                                  teacherProfileDetails.cv
                                )}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="view-button"
                              >
                                View
                              </a>
                            )}
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Box>
                </Box>

                <Box className="flex flex-wrap items-center content-center gap-4 self-stretch p-3 rounded-md bg-[#FFF] w-[100%]">
                  <Typography className="account-section-heading">
                    {translate('myAccount', 'notificationsText')}
                  </Typography>
                  <Box className="flex justify-between items-center content-center gap-4 self-stretch p-3 rounded-md bg-[#FAFAFA] w-[100%]">
                    <Box className="flex items-start gap-4">
                      <img src={EmailNotificationIcon} alt="email" />
                      <Box className="flex flex-col gap-1">
                        <div className="teacher-profile-email-notificatio-text">
                          {translate('myAccount', 'emailNotificationText')}
                        </div>
                        <div className="teacher-profile-email-notificatio-message">
                          {translate('myAccount', 'emailNotificationDescriptionText')}
                        </div>
                      </Box>
                    </Box>
                    <Switch
                      checked={emailNotificationChecked}
                      onChange={handleEmailNotificationChange}
                      inputProps={{ 'aria-label': 'controlled' }}
                    />
                  </Box>
                  <Box className="flex justify-between items-center content-center gap-4 self-stretch p-3 rounded-md bg-[#FAFAFA] w-[100%]">
                    <Box className="flex items-start gap-4">
                      <NotificationBing size="24" color="#14171F" variant="Outline" />
                      <Box className="flex flex-col gap-1">
                        <div className="teacher-profile-email-notificatio-text">
                          {translate('myAccount', 'pushNotificationText')}
                        </div>
                        <div className="teacher-profile-email-notificatio-message">
                          {translate('myAccount', 'pushNotificationDescriptionText')}
                        </div>
                      </Box>
                    </Box>
                    <Switch
                      checked={pushNotificationChecked}
                      onChange={handlePushNotificationChange}
                      inputProps={{ 'aria-label': 'controlled' }}
                    />
                  </Box>
                </Box>
                <Box className="flex flex-wrap items-center content-center gap-4 self-stretch p-3 rounded-md bg-[#FFF] w-[100%]">
                  <Typography className="account-section-heading">
                    {translate('myAccount', 'manageAccountsText')}
                  </Typography>
                  {/* <Box
                    className="flex justify-between items-center content-center gap-4 self-stretch p-3 rounded-md bg-[#FAFAFA] w-[100%] cursor-pointer"
                    onClick={handleWalletClick}
                  >
                    <Box className="flex items-center gap-3">
                      <img src={WalletIcon} alt="wallet" />
                      <div className="teacher-profile-email-notificatio-text">
                        {translate('myAccount', 'walletText')}
                      </div>
                    </Box>
                    <img src={ArrowForwardIcon} alt="arrow" />
                  </Box> */}
                  <Box
                    className="flex justify-between items-center content-center gap-4 self-stretch p-3 rounded-md bg-[#FAFAFA] w-[100%] cursor-pointer"
                    onClick={handleEditSpecialisationClick}
                  >
                    <Box className="flex items-center gap-3">
                      <PiBookOpenText size={24} color="#000" />
                      <div className="teacher-profile-email-notificatio-text">
                        Edit Specialisation
                      </div>
                    </Box>
                    <img src={ArrowForwardIcon} alt="arrow" />
                  </Box>
                  <Box
                    className="flex justify-between items-center content-center gap-4 self-stretch p-3 rounded-md bg-[#FAFAFA] w-[100%] cursor-pointer"
                    onClick={handleRescheduledRequestClick}
                  >
                    <Box className="flex items-center gap-3">
                      <MdOutlineTimelapse size={24} color="#000" />
                      <div className="teacher-profile-email-notificatio-text">
                        Reschedule Request
                      </div>
                    </Box>
                    <img src={ArrowForwardIcon} alt="arrow" />
                  </Box>
                  <Box
                    className="flex justify-between items-center content-center gap-4 self-stretch p-3 rounded-md bg-[#FAFAFA] w-[100%] cursor-pointer"
                    onClick={handleGenderPreferenceClick}
                  >
                    <Box className="flex items-center gap-3">
                      <img src={GenderPreferenceIcon} alt="gender" size={24} color="#000" />
                      <div className="teacher-profile-email-notificatio-text">
                        {translate('myAccount', 'genderPreferenceText')}
                      </div>
                    </Box>
                    <img src={ArrowForwardIcon} alt="arrow" />
                  </Box>

                  <Box
                    className="flex justify-between items-center content-center gap-4 self-stretch p-3 rounded-md bg-[#FAFAFA] w-[100%] cursor-pointer"
                    onClick={handlePasswordManagerClick}
                  >
                    <Box className="flex items-center gap-3">
                      <img src={PasswordManagerIcon} alt="password" />
                      <div className="teacher-profile-email-notificatio-text">
                        {translate('myAccount', 'passwordManagerText')}
                      </div>
                    </Box>
                    <img src={ArrowForwardIcon} alt="arrow" />
                  </Box>
                  <Box
                    className="flex justify-between items-center content-center gap-4 self-stretch p-3 rounded-md bg-[#FAFAFA] w-[100%] cursor-pointer"
                    onClick={handleSupportHelpClick}
                  >
                    <Box className="flex items-center gap-3">
                      <MdOutlineSupportAgent size={24} color="#000" />
                      <div className="teacher-profile-email-notificatio-text">Support & Help</div>
                    </Box>
                    <img src={ArrowForwardIcon} alt="arrow" />
                  </Box>
                  {/* <Box
                    className="flex justify-between items-center content-center gap-4 self-stretch p-3 rounded-md bg-[#FAFAFA] w-[100%] cursor-pointer"
                    onClick={handleLanguagePreferenceClick}
                  >
                    <Box className="flex items-center gap-3">
                      <img src={LanguagePreferenceIcon} alt="language" />
                      <div className="teacher-profile-email-notificatio-text">
                        {translate('myAccount', 'languagePreferenceText')}
                      </div>
                    </Box>
                    <img src={ArrowForwardIcon} alt="arrow" />
                  </Box> */}
                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                    PaperProps={{
                      sx: { width: '350px', maxHeight: '400px' },
                    }}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                  >
                    <Typography sx={{ p: 2, fontWeight: 'bold' }}>
                      {translate('myAccount', 'selectLanguagesText') || 'Select Language'}
                    </Typography>
                    <Divider />

                    {LanguageArray.map(language => {
                      const isSelected = currentLanguage === language.code;

                      return (
                        <MenuItem
                          key={language.code}
                          onClick={() => {
                            setCurrentLanguage(language.code);
                            handleMenuClose();
                          }}
                          sx={{
                            backgroundColor: isSelected ? 'rgba(10, 94, 243, 0.08)' : 'transparent',
                            '&:hover': {
                              backgroundColor: isSelected
                                ? 'rgba(10, 94, 243, 0.12)'
                                : 'rgba(0, 0, 0, 0.04)',
                            },
                          }}
                        >
                          <Box className="flex gap-2 items-center justify-between w-full">
                            <div>{language.lang}</div>
                            {isSelected && (
                              <Box
                                sx={{
                                  width: 16,
                                  height: 16,
                                  borderRadius: '50%',
                                  backgroundColor: '#0A5EF3',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                <Box
                                  component="span"
                                  sx={{
                                    width: 6,
                                    height: 6,
                                    backgroundColor: 'white',
                                    borderRadius: '50%',
                                  }}
                                />
                              </Box>
                            )}
                          </Box>
                        </MenuItem>
                      );
                    })}
                  </Menu>
                </Box>
              </Box>
            </Fade>
          </Box>
        </Box>
        {openPasswordManagerModal && (
          <PasswordManagerModal
            openPasswordManagerModal={openPasswordManagerModal}
            setOpenPasswordManagerModal={setOpenPasswordManagerModal}
          />
        )}
        {openSupportHelpModal && (
          <SupportHelpModal
            openSupportHelpModal={openSupportHelpModal}
            setOpenSupportHelpModal={setOpenSupportHelpModal}
          />
        )}
        {openGenderPreferenceModal && (
          <GenderPreferenceModal
            openGenderPreferenceModal={openGenderPreferenceModal}
            setOpenGenderPreferenceModal={setOpenGenderPreferenceModal}
            teacherProfileDetails={teacherProfileDetails}
            onUpdated={refreshTeacherProfileQuietly}
          />
        )}
        {openInstantAvailabilityModal && (
          <SetInstantAvailability
            isOpen={openInstantAvailabilityModal}
            onClose={handleCloseInstantAvailabilityModal}
            onConfirm={handleConfirmAvailability}
            duration={availabilityDuration}
            timeRemaining={timeRemaining}
          />
        )}
      </Box>
    </Layout>
  );
};

export default MyAccount;
